import { render, staticRenderFns } from "./DeviceOtherInfo.vue?vue&type=template&id=32e79989&scoped=true"
import script from "./DeviceOtherInfo.vue?vue&type=script&lang=js"
export * from "./DeviceOtherInfo.vue?vue&type=script&lang=js"
import style0 from "./DeviceOtherInfo.vue?vue&type=style&index=0&id=32e79989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e79989",
  null
  
)

export default component.exports